document.addEventListener( "DOMContentLoaded", function () 
{
    const yearSelectItems = document.querySelectorAll( ".year-select" );
    const articleItems = document.querySelectorAll( ".op-articles" );

    yearSelectItems.forEach( function ( item ) 
    {
        item.addEventListener( "click", function () 
        {
            const selectedYear = this.dataset.year;

            articleItems.forEach( function ( article ) 
            {
                article.style.display = "none";
            });

            const articlesToShow = document.querySelectorAll(
                `.op-articles[data-year="${selectedYear}"]`
            );
            articlesToShow.forEach( function ( article ) 
            {
                article.style.display = "flex";
            });

            yearSelectItems.forEach(function (yearItem) {
                yearItem.classList.remove("active");
            });

            this.classList.add("active");
        });
    });
});
